var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-line-selector"},_vm._l((_vm.getPersonalTypes),function(item){return _c('div',{key:item.id,staticClass:"order-line-selector_item",class:{active: item.selected},on:{"click":function($event){return _vm.onClick(item.id)}}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ac54ab0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-svg-inline-loader/dist/index.min.js!./src/components/Order/PersonalTypeSelector.vue
// module id = Q2ly
// module chunks = 1